import React from 'react';
import {ButtonBar, AddButton} from '../commons/Forms.js';
import ReactSpinner from 'react-spinjs';
import {connect} from 'react-redux';
import {fetchUsers} from '../../redux/users/actions';
import {Status, NEW_ELEMENT_ID} from '../../redux/_commons/const';
import {Pane, Part} from '../commons/Panes';

import UserEditionForm from './UserEditionForm';

import '../../styles/adminPanels.less';

/** Liste des utilisateurs à modifier/supprimer et ajout */
@connect(
  state => ({users: state.users}),
  {fetchUsers}
)
export default class UsersEdit extends React.Component {

  constructor() {
    super();
    this.state = {
      selectedUserId: null
    }
  }

  componentDidMount() {
    this.props.fetchUsers();
  }


  /** Retourne la liste des utilisateurs ou un message de status */
  getItems() {
    const {users} = this.props;

    if (!users || users.items === undefined || users.status === Status.LOADING) {
      return Status.LOADING;
    } else if (users.status === Status.FAILURE) {
      return Status.FAILURE;
    } else {
      return users.items;
    }
  }

  getTitle() {
    const content = this.getItems();
    let count = '...';
    if (Status.isAvailable(content)) {
      count = content.size;
    }

    return `Utilisateurs (${count})`;
  }

  getContent() {
    const users = this.getItems();
    const onSelect = (user) => this.setState({selectedUserId: user.id});
    const {selectedUserId} = this.state;

    if (!Status.isLoaded(users)) {
      return <ReactSpinner/>;
    } else if (!Status.isAvailable(users)) {
      return (<div className='err'> Une erreur a eu lieu</div>);
    }

    return (
      <div>
        {users.valueSeq().toJS().map(
          item => <UserItem key={item.id} item={item} onSelect={onSelect}
                            selected={selectedUserId !== null && selectedUserId === item.id}/>)}
      </div>
    );
  }

  /** Désactive la sélection si l'utilisateur sélectionné a été supprimé */
  componentWillReceiveProps(nextProps) {
    const {users} = nextProps;
    if (!users.items.has(this.state.selectedUserId)) {
      this.setState({selectedUserId: null});
    }
  }

  render() {
    const {selectedUserId} = this.state;
    const {inProgress} = this.props.users;

    return (
      <div>
        <Pane title="Liste des utilisateurs">
          <Part title={ this.getTitle() }>
            <div style={{minHeight: 200, position: 'relative'}}>
              { this.getContent() }
            </div>

            <ButtonBar>
              <AddButton onClick={() => this.setState({selectedUserId: NEW_ELEMENT_ID})}/>
            </ButtonBar>
          </Part>
        </Pane>
        {selectedUserId !== null ?
          <UserEditionForm
            user={selectedUserId === NEW_ELEMENT_ID ? {id: NEW_ELEMENT_ID} : this.props.users.items.get(selectedUserId)}
            inProgress={inProgress.includes(selectedUserId)}
            onCancel={() => this.setState({selectedUserId: null})}/>
          : null}
      </div>
    )
  }
}

/** Element utilisateur de la liste */
let UserItem = ({item, onSelect, selected}) => {
  return (
    <div className={['groomer-item', selected ? 'selected' : null].join(' ')}
         onClick={() => onSelect(item)}>
      <i style={{float: 'left'}} className="mi mi-chevron-left"/>
      <span>{item.name}</span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/admin/UsersEdit.js